import { Add as AddIcon } from '@mui/icons-material';
import { Button } from '@sb/cc-design-system';
import { PublicationModalV2 } from 'src/components/modal';
import { useModal } from 'src/hooks';
import { PublicationTypes } from 'src/interfaces';
import { lang } from 'src/utils';

import { PublishActionButtonProps } from './PublishActionButton.interface';

export const PublishActionButton = ({
  label = lang.publish,
  locationCodes = [],
  locationGroupIDs,
  assemblyIds,
  publicationType = PublicationTypes.OVERRIDES,
  onPublished,
  size = 'sm',
  startIcon = <AddIcon />,
  variant = 'outlined-secondary-1',
  ...rest
}: PublishActionButtonProps) => {
  const publishModal = useModal();

  return (
    <>
      <Button
        variant={variant}
        size={size}
        startIcon={startIcon}
        onClick={publishModal.onOpenModal}
        {...rest}>
        {label}
      </Button>

      {publishModal.open && (
        <PublicationModalV2
          title={lang.publicationModal.title}
          subTitle={lang.publicationModal.subTitle}
          confirmText={lang.publish}
          cancelText={lang.cancel}
          locationCodes={locationCodes}
          locationGroupIDs={locationGroupIDs}
          assemblyIds={assemblyIds}
          publicationType={publicationType}
          open={publishModal.open}
          onClose={publishModal.onCloseModal}
          publishMessage={lang.successfullyPublished}
          onPublished={onPublished}
        />
      )}
    </>
  );
};
